import { useEffect, useState } from 'react';
import { Share2, Globe, Lock } from 'lucide-react';

interface Share {
  id: string;
  name: string;
  path: string;
  protocol: 'smb' | 'nfs' | 'afp';
  readonly: boolean;
  guest: boolean;
  online: boolean;
}

export default function Shares() {
  const [shares, setShares] = useState<Share[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/v1/shares', { credentials: 'include' })
      .then((r) => r.json())
      .then((res) => setShares(res.data || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="p-8 text-center text-slate-500">Loading shares...</div>;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-slate-900 dark:text-white">NAS Shares</h1>
        <button className="px-4 py-2 bg-sky-600 hover:bg-sky-700 text-white text-sm font-medium rounded-md transition-colors">
          Add Share
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {shares.map((s) => (
          <div key={s.id} className="rounded-lg border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2 font-medium text-slate-900 dark:text-white">
                <Share2 size={18} />
                {s.name}
              </div>
              <span className={`text-xs px-2 py-1 rounded-full ${s.online ? 'bg-emerald-100 text-emerald-700' : 'bg-rose-100 text-rose-700'}`}>
                {s.online ? 'Online' : 'Offline'}
              </span>
            </div>
            <div className="text-sm text-slate-500 dark:text-slate-400 mb-3">{s.path}</div>
            <div className="flex items-center gap-4 text-xs text-slate-600 dark:text-slate-400">
              <span className="flex items-center gap-1 uppercase">{s.protocol}</span>
              <span className="flex items-center gap-1">{s.readonly ? <Lock size={12} /> : <Globe size={12} />}{s.readonly ? 'Read-only' : 'Writable'}</span>
              <span>Guest {s.guest ? 'on' : 'off'}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
